export const isEgDomain = (): boolean => {
    if (typeof window === 'undefined') return false
    const host = window.location.hostname.toLowerCase()
    return host.includes('eg.flyin.com') || host.includes('meeg.flyin.com')
}

export default isEgDomain
